import { Link, NavLink } from "react-router-dom";
import { Logo, ThemeGlyph } from "../Logo";
import type { Theme } from "../../lib/theme";

export function Nav({
  theme,
  onToggleTheme,
  onSignIn,
  onGetStarted,
}: {
  theme: Theme;
  onToggleTheme: () => void;
  onSignIn: () => void;
  onGetStarted: () => void;
}) {
  return (
    <header className="nav">
      <div className="container nav-inner">
        <Link to="/" aria-label="Slackcord home">
          <Logo />
        </Link>
        <nav className="nav-links" aria-label="Primary">
          <NavLink to="/how-it-works">How it works</NavLink>
          <NavLink to="/pricing">Pricing</NavLink>
          <NavLink to="/security">Security</NavLink>
        </nav>
        <div className="nav-actions">
          <button
            className="theme-toggle"
            onClick={onToggleTheme}
            aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
          >
            <ThemeGlyph theme={theme} />
          </button>
          <button className="btn btn-ghost btn-sm" onClick={onSignIn}>
            Sign in
          </button>
          <button className="btn btn-primary btn-sm" onClick={onGetStarted}>
            Join the waitlist
          </button>
        </div>
      </div>
    </header>
  );
}
